var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2487 24.1673H21.7487C23.0834 24.1673 24.1654 23.0854 24.1654 21.7507V7.25065C24.1654 5.91596 23.0834 4.83398 21.7487 4.83398H7.2487C5.91401 4.83398 4.83203 5.91596 4.83203 7.25065V21.7507C4.83203 23.0854 5.91401 24.1673 7.2487 24.1673Z",
    stroke: "white",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10281 24.1673H13.7275C14.4294 24.1673 14.9983 23.0854 14.9983 21.7507V7.25065C14.9983 5.91596 14.4294 4.83398 13.7275 4.83398H6.10281C5.40098 4.83398 4.83203 5.91596 4.83203 7.25065V21.7507C4.83203 23.0854 5.40098 24.1673 6.10281 24.1673Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30859 14.4993H8.90736C9.36504 14.4993 9.78344 14.7579 9.98812 15.1673L12.0708 19.3327L16.9041 9.66602L18.9868 13.8314C19.1915 14.2408 19.61 14.4993 20.0676 14.4993H26.4314",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.81,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.258b47cda137013a076bb5725e2bfdc6.svg";
export { ForwardRef as ReactComponent };